module.exports = __webpack_public_path__ + "static/media/logAltitude.8e46880a.svg";